import React from 'react'

import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import type { SxProps } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'

interface SelectionBoxProps {
  checked?: boolean
  label: string
  sx?: SxProps
  tooltip?: string
  value: string | number
}

/** TODO: Move this component to KyperMUI **/
const SelectionBox: React.FC<SelectionBoxProps> = ({
  checked = false,
  label,
  sx = {},
  tooltip = '',
  value,
}) => {
  const theme = useTheme()

  /** TODO: Add new theme color to handle this color and remove the mode check **/
  const greyColor =
    theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]
  const borderColor = checked ? theme.palette.action.active : greyColor
  const borderSize = checked ? 3 : 1

  return (
    <Box
      bgcolor="background.paper"
      border={`${borderSize}px solid`}
      borderColor={borderColor}
      borderRadius={2}
      mt={-2}
      mx={8}
      pr={8}
      py={4}
      sx={{ '&:hover': { borderColor: theme.palette.action.active }, ...sx }}
    >
      <Tooltip title={tooltip}>
        <FormControlLabel
          control={
            <Radio
              disableRipple={true}
              sx={{ '&.Mui-checked': { color: theme.palette.action.active } }}
            />
          }
          label={label}
          labelPlacement="start"
          sx={{ ml: 0, pl: 8 }}
          value={value}
        />
      </Tooltip>
    </Box>
  )
}

export default SelectionBox
